import { useStrings } from "@1js/localization-components";
import {
  Body1,
  Image,
  makeStyles,
  Subtitle1,
} from "@fluentui/react-components";
import React from "react";
import {
  SearchWentWrongHeading,
  SearchWentWrongSubheading1,
  SearchWentWrongSubheading2,
} from "./SearchedPrompts.strings";

export const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "90px",
    gap: "9px",
  },
});

export const SearchWentWrong: React.FC = () => {
  const styles = useStyles();
  const localizations = useStrings({
    SearchWentWrongHeading,
    SearchWentWrongSubheading1,
    SearchWentWrongSubheading2,
  });

  return (
    <div className={styles.root}>
      <Image
        src="https://copilot.cloud.microsoft/images/0013-exclamation-mark-d-standard-128x128.webp"
        aria-labelledby="search-error-heading"
      />
      <Subtitle1 id="search-error-heading">
        {localizations.SearchWentWrongHeading()}
      </Subtitle1>
      <Body1>{localizations.SearchWentWrongSubheading1()}</Body1>
      <Body1>{localizations.SearchWentWrongSubheading2()}</Body1>
    </div>
  );
};
